import '../css/global.css';
import { navbarBold, watchKeyboardEvents } from './navigation.js';

navbarBold();
watchKeyboardEvents();
